// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3Z1j6","subtitle":"classes_subtitle__3WRAT"};